// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  font-family: eurostile, sans-serif;
  max-width: 100%;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2%;
  border-bottom: 2px solid #be1a1a;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}
header img {
  width: 40%;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5));
}
@media (min-width: 1200px) {
  header img {
    width: 20%;
  }
}
header h1 {
  font-size: 1.3rem;
}
@media (min-width: 1200px) {
  header h1 {
    font-size: 2.5rem;
  }
}

#notesIcon {
  animation: growIcon 3s infinite;
}

@keyframes growIcon {
  0% {
    transform: scale(1);
    z-index: 2;
  }
  50% {
    transform: scale(1.5);
    z-index: 2;
  }
  100% {
    transform: scale(1);
    z-index: 2;
  }
}
.Home {
  display: flex;
  flex-direction: column;
}
.Home h2 {
  text-align: center;
  text-transform: uppercase;
  font-size: 1.2rem;
}

.form {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background-color: rgba(126, 209, 242, 0.5);
  padding: 30px;
}
.form select {
  border: 1px solid #be1a1a;
  border-radius: 10px;
  margin-bottom: 2%;
}
@media (min-width: 768px) {
  .form select {
    width: 40%;
    font-size: 1.2rem;
  }
}
@media (min-width: 1200px) {
  .form select {
    width: 100%;
  }
}
.form label span {
  color: #be1a1a;
}
@media (min-width: 768px) {
  .form label {
    font-size: 1.2rem;
  }
}
.form input {
  border: 1px solid #be1a1a;
  border-radius: 10px;
  margin-bottom: 2%;
}
@media (min-width: 768px) {
  .form input {
    width: 40%;
    font-size: 1.2rem;
  }
}
@media (min-width: 1200px) {
  .form input {
    width: 100%;
  }
}
.form textarea {
  border: 1px solid #be1a1a;
  border-radius: 10px;
  margin-bottom: 2%;
}
@media (min-width: 768px) {
  .form textarea {
    width: 40%;
    font-size: 1.2rem;
  }
}
@media (min-width: 1200px) {
  .form textarea {
    width: 100%;
  }
}
.form .button {
  width: 30%;
  margin: auto;
}
@media (min-width: 768px) {
  .form .button {
    width: 25%;
  }
}
@media (min-width: 1200px) {
  .form .button {
    width: 15%;
  }
}

.status {
  display: flex;
  flex-direction: column;
}
.status .radio {
  display: flex;
  justify-content: center;
}
.status .radio input {
  width: 60%;
  border-radius: 5px;
}
.status .searchResults {
  align-self: center;
}
.status table {
  border-collapse: collapse;
  margin-top: 2%;
}
.status table tr,
.status table th,
.status table td {
  text-align: center;
  border: 1px solid #000;
}
.status table tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.2);
}
.status table .button {
  margin-top: 2%;
}
@media (min-width: 300px) and (max-width: 1200px) {
  .status table {
    /*hide table headers*/
    /*label the data*/
  }
  .status table table,
  .status table tbody,
  .status table th,
  .status table td,
  .status table tr {
    display: block;
    /* word-wrap: break-word */
  }
  .status table th {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .status table tr {
    margin: 0 0 1rem 0;
  }
  .status table td {
    /* behave like a row */
    border: none;
    border-bottom: 1px solid #333;
    position: relative;
    padding-left: 50%;
  }
  .status table td:before {
    /* act as table heeader */
    position: absolute;
    top: 0;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    border-right: 1px solid #333;
  }
  .status table td:nth-of-type(1):before {
    content: "Site";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(2):before {
    content: "Date";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(3):before {
    content: "Machine Number";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(4):before {
    content: "Machine Make";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(5):before {
    content: "Serial Number";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(6):before {
    content: "Issue";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(7):before {
    content: "Status";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(8):before {
    content: "Description";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(9):before {
    content: "Image";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(10):before {
    content: "Notes";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(11):before {
    content: "Notes";
    font-weight: bold;
    color: #1d1d1d;
  }
  .status table td:nth-of-type(12):before {
    content: "Status Log";
    font-weight: bold;
    color: #1d1d1d;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAuBA;EACE,sBAAA;EACA,kCAAA;EACA,eAAA;AAtBF;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,gCAAA;AAvBF;AAyBE;EACE,UAAA;EACA,mDAAA;AAvBJ;AAyBI;EAJF;IAKI,UAAA;EAtBJ;AACF;AAyBE;EACE,iBAAA;AAvBJ;AAyBI;EAHF;IAII,iBAAA;EAtBJ;AACF;;AA2BA;EACE,+BAAA;AAxBF;;AA2BA;EACE;IAGD,mBAAA;IACA,UAAA;EAxBC;EA0BA;IAGD,qBAAA;IACA,UAAA;EAxBC;EA0BA;IAGD,mBAAA;IACA,UAAA;EAxBC;AACF;AA4BA;EACE,aAAA;EACA,sBAAA;AA1BF;AA4BE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;AA1BJ;;AA8BA;EACE,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,0CAnGU;EAoGV,aAAA;AA5BF;AA8BE;EA9FA,yBAAA;EACA,mBAAA;EACA,iBAAA;AAmEF;AAjEE;EA0FA;IAzFE,UAAA;IACA,iBAAA;EAoEF;AACF;AAlEE;EAqFA;IApFE,WAAA;EAqEF;AACF;AAqBI;EACE,cA/GA;AA4FN;AAsBI;EAPF;IAQI,iBAAA;EAnBJ;AACF;AAsBE;EA9GA,yBAAA;EACA,mBAAA;EACA,iBAAA;AA2FF;AAzFE;EA0GA;IAzGE,UAAA;IACA,iBAAA;EA4FF;AACF;AA1FE;EAqGA;IApGE,WAAA;EA6FF;AACF;AAUE;EAlHA,yBAAA;EACA,mBAAA;EACA,iBAAA;AA2GF;AAzGE;EA8GA;IA7GE,UAAA;IACA,iBAAA;EA4GF;AACF;AA1GE;EAyGA;IAxGE,WAAA;EA6GF;AACF;AAFE;EACE,UAAA;EACA,YAAA;AAIJ;AAFI;EAJF;IAKI,UAAA;EAKJ;AACF;AAHI;EARF;IASI,UAAA;EAMJ;AACF;;AADA;EACE,aAAA;EACA,sBAAA;AAIF;AAFE;EACE,aAAA;EACA,uBAAA;AAIJ;AAFI;EACE,UAAA;EACA,kBAAA;AAIN;AADE;EACE,kBAAA;AAGJ;AAAE;EACE,yBAAA;EACA,cAAA;AAEJ;AAAI;;;EAGE,kBAAA;EACA,sBAAA;AAEN;AAAI;EACE,oCAAA;AAEN;AACI;EACE,cAAA;AACN;AAEI;EAlBF;IA6BI,qBAAA;IA8BA,iBAAA;EAtCJ;EADI;;;;;IAKE,cAAA;IACA,0BAAA;EAGN;EACI;IACE,kBAAA;IACA,YAAA;IACA,aAAA;EACN;EAEI;IACE,kBAAA;EAAN;EAGI;IACE,sBAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;EADN;EAII;IACE,yBAAA;IACA,kBAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,4BAAA;EAFN;EAMI;IACE,eAAA;IACA,iBAAA;IACA,cAAA;EAJN;EAQI;IACE,eAAA;IACA,iBAAA;IACA,cAAA;EANN;EASI;IACE,yBAAA;IACA,iBAAA;IACA,cAAA;EAPN;EAUI;IACE,uBAAA;IACA,iBAAA;IACA,cAAA;EARN;EAWI;IACE,wBAAA;IACA,iBAAA;IACA,cAAA;EATN;EAYI;IACE,gBAAA;IACA,iBAAA;IACA,cAAA;EAVN;EAaI;IACE,iBAAA;IACA,iBAAA;IACA,cAAA;EAXN;EAcI;IACE,sBAAA;IACA,iBAAA;IACA,cAAA;EAZN;EAeI;IACE,gBAAA;IACA,iBAAA;IACA,cAAA;EAbN;EAgBI;IACE,gBAAA;IACA,iBAAA;IACA,cAAA;EAdN;EAiBI;IACE,gBAAA;IACA,iBAAA;IACA,cAAA;EAfN;EAkBI;IACE,qBAAA;IACA,iBAAA;IACA,cAAA;EAhBN;AACF","sourcesContent":["$rtp: #be1a1a;\n$lightBlue: rgba(126, 209, 242, .5);\n$darkBlue: #00428d;\n\n$mobile: 300px;\n$tablet: 768px;\n$pc: 1200px;\n\n@mixin input {\n  border: 1px solid $rtp;\n  border-radius: 10px;\n  margin-bottom: 2%;\n\n  @media (min-width: $tablet) {\n    width: 40%;\n    font-size: 1.2rem;\n  }\n\n  @media (min-width: $pc) {\n    width: 100%;\n  }\n}\n\n* {\n  box-sizing: border-box;\n  font-family: eurostile, sans-serif;\n  max-width: 100%;\n}\n\n\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2%;\n  border-bottom: 2px solid $rtp;\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 30px;\n\n  img {\n    width: 40%;\n    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, .5));\n\n    @media (min-width: $pc) {\n      width: 20%;\n    }\n  }\n\n  h1 {\n    font-size: 1.3rem;\n\n    @media (min-width: $pc) {\n      font-size: 2.5rem;\n    }\n  }\n\n}\n\n#notesIcon {\n  animation: growIcon 3s infinite;\n}\n\n@keyframes growIcon {\n  0% {\n      -webkit-transform:scale(1);\n -moz-transform:scale(1);\n transform:scale(1);\n z-index:2;\n  }\n  50% {\n      -webkit-transform:scale(1.5);\n -moz-transform:scale(1.5);\n transform:scale(1.5);\n z-index:2;\n  }\n  100% {\n      -webkit-transform:scale(1);\n -moz-transform:scale(1);\n transform:scale(1);\n z-index:2;\n \n  }\n}\n\n.Home {\n  display: flex;\n  flex-direction: column;\n\n  h2 {\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 1.2rem;\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  // border:2px solid $darkBlue;\n  border-radius: 20px;\n  background-color: $lightBlue;\n  padding:30px;\n\n  select {\n    @include input()\n  }\n\n  label {\n    // margin-bottom: 2%;\n\n    span {\n      color: $rtp;\n    }\n\n    @media (min-width: $tablet) {\n      font-size: 1.2rem;\n    }\n  }\n\n  input {\n    @include input()\n  }\n\n  textarea {\n    @include input()\n  }\n\n  .button {\n    width: 30%;\n    margin: auto;\n\n    @media(min-width: $tablet) {\n      width: 25%;\n    }\n\n    @media(min-width: $pc) {\n      width: 15%;\n    }\n\n  }\n}\n\n.status {\n  display: flex;\n  flex-direction: column;\n\n  .radio {\n    display: flex;\n    justify-content: center;\n\n    input {\n      width: 60%;\n      border-radius: 5px;\n    }\n  }\n  .searchResults{\n    align-self: center;\n  }\n\n  table {\n    border-collapse: collapse;\n    margin-top: 2%;\n\n    tr,\n    th,\n    td {\n      text-align: center;\n      border: 1px solid #000;\n    }\n    tr:nth-child(even){\n      background-color: rgba(0,0,0,.2);\n    }\n\n    .button {\n      margin-top: 2%;\n    }\n\n    @media(min-width: $mobile) and (max-width: $pc) {\n\n      table,\n      tbody,\n      th,\n      td,\n      tr {\n        display: block;\n        /* word-wrap: break-word */\n      }\n\n      /*hide table headers*/\n      th {\n        position: absolute;\n        top: -9999px;\n        left: -9999px;\n      }\n\n      tr {\n        margin: 0 0 1rem 0;\n      }\n\n      td {\n        /* behave like a row */\n        border: none;\n        border-bottom: 1px solid #333;\n        position: relative;\n        padding-left: 50%;\n      }\n\n      td:before {\n        /* act as table heeader */\n        position: absolute;\n        top: 0;\n        left: 6px;\n        width: 45%;\n        padding-right: 10px;\n        white-space: nowrap;\n        border-right: 1px solid #333;\n      }\n\n      /*label the data*/\n      td:nth-of-type(1):before {\n        content: \"Site\";\n        font-weight: bold;\n        color: #1d1d1d;\n\n      }\n\n      td:nth-of-type(2):before {\n        content: \"Date\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(3):before {\n        content: \"Machine Number\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(4):before {\n        content: \"Machine Make\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(5):before {\n        content: \"Serial Number\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(6):before {\n        content: \"Issue\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(7):before {\n        content: \"Status\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(8):before {\n        content: \"Description\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(9):before {\n        content: \"Image\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(10):before {\n        content: \"Notes\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n      \n      td:nth-of-type(11):before {\n        content: \"Notes\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n\n      td:nth-of-type(12):before {\n        content: \"Status Log\";\n        font-weight: bold;\n        color: #1d1d1d;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
